// The mounted root component, set by main.js. Kept out of main.js so entities
// can read it without importing the whole app (and its router and views).
let instance = null;

export function setAppInstance(value) {
  instance = value;
}

export function appInstance() {
  return instance;
}
